const Footer = () => {
  return (
    <footer id="Footer_article" className="fr">
      <h4 id="Footer_copyright">©2022 Rodi Hamame</h4>
    </footer>
  );
};

export default Footer;
